<script>
import {mapActions, mapGetters} from "vuex";
import {apiCall} from "@/utils/api";
import {ValidationObserver, ValidationProvider} from "vee-validate";

export default {
  name: "NotificationsCenter",
  components: {ValidationObserver, ValidationProvider },
  data(context) {
    return {
      footerProps: {
        "items-per-page-options": [10, 20, 50],
      },
      inuse: false,
      invalidForm: true,
      totalUsers: 0,
      users: [],
      roles: [],
      selectableroles: [],
      companies: [],
      divisions: [],
      locations: [],
      loading: true,
      options: {
        sortBy: ["firstname"],
        sortDesc: [true]
      },
      filteredrole: 4,
      filteredcompany: 0,
      searchValue: null,
      filteredDivision: 0,
      filteredLocation: 0,
      search: null,
      page: 1,
      headers: [
        {
          text: context.$t('employeeid'),
          align: "start",
          value: "employeeid",
          sortable: true,
        },
        {text: context.$t('firstname'), value: "firstname", sortable: true},
        {text: context.$t('lastname'), value: "lastname", sortable: true},
        {text: context.$t('email'), value: "username", sortable: true},
        {text: context.$t('company'), value: "company", sortable: true},
        {text: context.$t('date_created'), value: "createddate", sortable: false},
      ],
      filteredDivisions: [{id: 0, name: context.$t('all')},],
      filteredLocations: [{id: 0, name: context.$t('all')},],
      selectedUsers: [],
      allSelected: false,
      excluded: [],
      emojis: ['😀','😃','😄','😁','😆','😅','😂','😉','😊','😍','😘','😎','😢','😭','😡','👍','👎','👏','🙏','💪','❤️','🔥','⭐','🎉','✅','❌','💯','👀'],
      notification: {
        users: [],
        title: null,
        body: null
      },
      dialog: false,
      confirmDialog: false,
      notificationResults: [],
      notificationResultsDialog: false

    }
  },
  computed: {
    ...mapGetters("auth", ["getProfile"]),
    token() {
      return this.getProfile.token;
    },
    superadmin() {
      return this.getProfile.roles.includes("Admin");
    },
    recipientCount() {
      return this.allSelected ? Math.max(this.totalUsers - this.excluded.length, 0) : this.selectedUsers.length;
    },
    tableSelected() {
      if (this.allSelected) {
        return this.users.filter(u => !this.excluded.includes(u.username));
      }
      return this.selectedUsers;
    },
    recipientsLabel() {
      return this.recipientCount > 0 ? this.$t('recipients_selected', [this.recipientCount]) : '';
    },
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    selectedUsers(val) {
      let arr = [];

      val.forEach(e => arr.push(e.username));
      this.notification.users = [...arr];

    }
  },
  async mounted() {

    if (this.superadmin) {
      await this.getCompanies();
    } else {
      await this.getCompanyDivisions();
    }
  },
  methods: {
    ...mapActions("service", ["setSnackbar"]),
    insertEmoji(emoji) {
      const field = this.$refs.bodyField && this.$refs.bodyField.$refs.input;
      const body = this.notification.body || '';
      const start = field ? field.selectionStart : body.length;
      const end = field ? field.selectionEnd : body.length;
      this.notification.body = body.slice(0, start) + emoji + body.slice(end);
      this.$nextTick(() => {
        if (field) {
          const pos = start + emoji.length;
          field.focus();
          field.setSelectionRange(pos, pos);
        }
      });
    },
    isSendDisabled() {
      return this.recipientCount === 0;
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.allSelected = false;
        this.excluded = [];
      } else {
        this.allSelected = true;
        this.selectedUsers = [];
        this.excluded = [];
      }
    },
    onItemSelected({ item, value }) {
      if (this.allSelected) {
        const idx = this.excluded.indexOf(item.username);
        if (value) {
          if (idx !== -1) this.excluded.splice(idx, 1);
        } else if (idx === -1) {
          this.excluded.push(item.username);
        }
      } else if (value) {
        if (!this.selectedUsers.some(u => u.username === item.username)) this.selectedUsers.push(item);
      } else {
        this.selectedUsers = this.selectedUsers.filter(u => u.username !== item.username);
      }
    },
    onToggleSelectAll({ items, value }) {
      if (this.allSelected) {
        items.forEach(item => {
          const idx = this.excluded.indexOf(item.username);
          if (value) {
            if (idx !== -1) this.excluded.splice(idx, 1);
          } else if (idx === -1) {
            this.excluded.push(item.username);
          }
        });
      } else if (value) {
        items.forEach(item => {
          if (!this.selectedUsers.some(u => u.username === item.username)) this.selectedUsers.push(item);
        });
      } else {
        const pageUsernames = new Set(items.map(i => i.username));
        this.selectedUsers = this.selectedUsers.filter(u => !pageUsernames.has(u.username));
      }
    },
    setSearch() {
      if (this.allSelected) this.excluded = [];
      this.searchValue = this.search;
      this.options = {...this.options, page: 1}
    },
    clearSearch() {
      if (this.allSelected) this.excluded = [];
      this.search = null;
      this.searchValue = this.search;

      this.$nextTick(() => {
        this.options = {...this.options, page: 1}
      });
    },
    allcompanies(companies) {
      let arr = [];
      arr = [
        ...companies,
      ];
      return arr;
    },
    async selectCompany() {
      if (this.allSelected) this.excluded = [];
      if (this.filteredcompany  === 0){
        this.filteredDivisions = [{id: 0, name: this.$t('all')}];
        this.filteredDivision = 0;
        this.filteredLocations = [{ id: 0, name: "All" }];
        this.filteredLocation = 0;
        this.options = {...this.options, page: 1}
        return;
      }
      await this.getFilteredDivisions();
      this.options = {...this.options, page: 1}
    },
    async selectDivision() {
      if (this.allSelected) this.excluded = [];
      if(this.filteredDivision != 0){
        await this.getFilteredLocations();
      }else{
        this.locations = [{ id: 0, name: "All" }];
        this.selectedLocation = 0;
      }
      this.options = {...this.options, page: 1}
    },
    selectLocation() {
      if (this.allSelected) this.excluded = [];
      this.options = {...this.options, page: 1}
    },
    async getCompanies() {
      apiCall("get", "companies/get", true).then((response) => {
        this.companies = response.data;
      });
    },
    async getCompanyDivisions() {
      await apiCall("get", `divisions/getcompanydivisions?exclude=leaderboard`, true).then(
          (response) => {
            this.filteredDivisions = [{ id: 0, name: "All" }, ...response.data];
            this.filteredDivision = response.data[0].id;
          }
      );
    },
    async getFilteredDivisions() {
      this.filteredDivision = 0;

      this.locations = [{ id: 0, name: "All" }];
      this.selectedLocation = 0;
      apiCall(
          "get",
          `divisions/get?companyid=${this.filteredcompany}`,
          true
      ).then((response) => {
        this.filteredDivisions = [{id: 0, name: this.$t('all')}, ...response.data];
      });
    },
    async getFilteredLocations() {
      this.filteredLocation = 0;
      apiCall(
          "get",
          `locations/get?divisionid=${this.filteredDivision}`,
          true
      ).then((response) => {

        this.filteredLocations = [{id: 0, name: this.$t('all')}, ...response.data];
      });
    },
    getDataFromApi() {
      this.loading = true;

      if (!this.superadmin) {
        this.filteredcompany = this.getProfile.companyid;
      }

      const params = {
        page: this.options.page - 1,
        sortDirection: this.options.sortDesc[0] == false ? "desc" : "asc",
        sortField: this.options.sortBy[0] || "firstname",
        perpage: this.options.itemsPerPage,
        companyid: this.filteredcompany,
        divisionid: this.filteredDivision,
        locationid: this.filteredLocation,
        roleid: this.filteredrole,
        search: this.searchValue,
        status: "Active",
      };

      apiCall(
          "get",
          "users",
          {
            params: params,
          },
          true
      ).then((response) => {
        this.users = response.data.content;

        this.users.forEach((elem) => {
          switch (elem.name) {
            case "Admin":
              elem.roletext = this.$t('super_admin');
              break;
            case "CompanyAdmin":
              elem.roletext = this.$t('company_admin');
              break;
            case "User":
              elem.roletext = this.$t("non_driver_user");
              break;
            case "Driver":
              elem.roletext = this.$t("driver");
              break;
            case "Manager":
              elem.roletext = this.$t("manager");
              break;
            case "Supervisor":
              elem.roletext = this.$t("supervisor");
              break;
            default:
              elem.roletext = elem.name;
              break;
          }
        });

        this.totalUsers = response.data.totalElements;
        this.loading = false;
      });
    },
    resetForm() {
      this.dialog = false;
      this.$nextTick(() => {
        this.options = {...this.options, page: 1};

        this.notification = Object.assign({}, {
          users: [],
          title: null,
          body: null
        },);
        this.filteredcompany = 0;
        this.searchValue = null;
        this.filteredDivision = 0;
        this.filteredLocation = 0;
        this.search = null;
        this.selectedUsers = [];
        this.allSelected = false;
        this.excluded = [];
      });
      this.$refs.observer.reset();
    },
      save() {
        this.confirmDialog = true;
      },
      confirmSend() {
        this.confirmDialog = false;
        this.sendNotification();
      },
      sendNotification() {
        this.inuse = true;
        this.loading = true;
        const params = {
          title: this.notification.title,
          body: this.notification.body,
          users: this.allSelected ? [] : this.notification.users,
          allSelected: this.allSelected,
          excluded: this.allSelected ? this.excluded : [],
          companyid: this.filteredcompany,
          divisionid: this.filteredDivision,
          locationid: this.filteredLocation,
          roleid: this.filteredrole,
          search: this.searchValue,
        };

        const recipientsMap = {};
        this.selectedUsers.forEach(u => { recipientsMap[u.username] = u; });

        apiCall(
            "post",
            "notifications/create",
            {
              data: params,
            },
            true
        )
            .then((response) => {
              this.inuse = false;
              const values = response.data.result.map(v => {
                const u = recipientsMap[v.email] || {};
                return {...v, firstname: u.firstname, lastname: u.lastname};
              });
              const errorsCount = values.filter(v => !v.result).length;

              if (errorsCount > 0) {
                this.notificationResults = values;
                this.notificationResultsDialog = true;
                this.selectedUsers = [];
                this.allSelected = false;
                this.excluded = [];
              }else {
                this.setSnackbar({
                  color: "success",
                  text: this.$t('notification_created'),
                  toggle: true,
                });
                this.resetForm();
              }
            })
            .catch(() => {
              this.inuse = false;
              this.setSnackbar({
                color: "error",
                text: this.$t('something_went_wrong'),
                toggle: true,
              });
            })
            .finally(() => {
              this.loading = false;
            });
      },
    closeNotificationResultsDialog() {
      this.notificationResultsDialog = false;
      this.notificationResults = [];
    }
    }
}
</script>

<template>
  <v-layout>
    <div class="col-12 elevation-0">
      <v-card class="elevation-0" >
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-form class="col-6" @submit.prevent="save">
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        readonly
                        :value="recipientsLabel"
                        :label="$t('recipients')"
                        :placeholder="$t('select_recipients')"
                        prepend-icon="mdi-account-multiple"
                        append-icon="mdi-menu-down"
                        @click="dialog = true"
                        @click:append="dialog = true"
                    ></v-text-field>
                  </v-col>
                  <!-- eslint-disable-next-line -->
                  <v-col cols="12">
                    <validation-provider
                        v-slot="{ errors }"
                        :name="$t('notification_title')"
                        rules="required"
                    >
                      <v-text-field
                          v-model="notification.title"
                          :label="$t('notification_title')"
                          :error-messages="errors"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider
                        v-slot="{ errors }"
                        :name="$t('notification_text')"
                        rules="required|max:250"
                    >
                      <div class="emoji-textarea">
                        <v-textarea
                            ref="bodyField"
                            :error-messages="errors"
                            :label="$t('notification_text')"
                            v-model="notification.body"
                            no-resize
                            rows="4"
                            counter="250"
                        ></v-textarea>
                        <v-menu :close-on-content-click="false" offset-y top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-bind="attrs"
                                v-on="on"
                                class="emoji-trigger"
                                :title="$t('add_emoji')"
                            >mdi-emoticon-happy-outline</v-icon>
                          </template>
                          <v-card class="pa-2 emoji-picker">
                            <span
                                v-for="e in emojis"
                                :key="e"
                                class="emoji-item"
                                @click="insertEmoji(e)"
                            >{{ e }}</span>
                          </v-card>
                        </v-menu>
                      </div>
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
              <v-btn
                  color="primary"
                  class="mb-2 confirm-button px-5"
                  :disabled="invalid || isSendDisabled()"
                  :loading="inuse"
                  @click="save"
              >
                {{ $t('send_notification') }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </validation-observer>

        <v-dialog v-model="dialog">
          <v-card>
            <v-data-table
                mobile-breakpoint="980"
                :headers="headers"
                :items="users"
                :server-items-length="totalUsers"
                :loading="loading"
                :footer-props="footerProps"
                :page="page"
                :options.sync="options"
                class="users-table"
                show-select
                item-key="username"
                :value="tableSelected"
                @item-selected="onItemSelected"
                @toggle-select-all="onToggleSelectAll"
            >
              <template v-slot:top>
                <v-toolbar class="flex-columned-toolbar" height="auto" flat>
                  <v-col class="py-4 col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xl-2 my-2 col-12">
                    <v-text-field
                        v-model="search"
                        prepend-icon="mdi-magnify"
                        :label="$t('search')"
                        single-line
                        hide-details
                        clearable
                        @keyup.enter.prevent="setSearch()"
                        @click:clear="clearSearch()"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-4 col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xl-2 my-2 col-12">
                    <v-select
                        v-if="superadmin"
                        hide-details
                        v-model="filteredcompany"
                        :items="allcompanies(companies)"
                        :label="$t('company')"
                        item-text="name"
                        item-value="id"
                        @change="selectCompany"
                    >
                    </v-select>
                  </v-col>
                  <v-col class="py-4 col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xl-2 my-2 col-12">
                    <v-select
                        hide-details
                        v-model="filteredDivision"
                        :items="filteredDivisions"
                        :label="$t('division')"
                        item-text="name"
                        item-value="id"
                        @change="selectDivision"
                    ></v-select>
                  </v-col>
                  <v-col class="py-4 col-xs-12 col-sm-4 col-md-3 col-lg-2 col-xl-2 my-0 col-12">
                    <v-select
                        v-model="filteredLocation"
                        :items="filteredLocations"
                        :label="$t('location')"
                        item-text="name"
                        item-value="id"
                        hide-details
                        @change="selectLocation"
                    ></v-select>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col class="py-4 col-xs-12 col-sm-4 col-md-3 col-lg-2 col-xl-2 my-2 col-12 d-flex align-center justify-end">
                    <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        @click="toggleSelectAll"
                    >
                      {{ allSelected ? $t('clear_selection') : $t('select_all') }}
                    </v-btn>
                  </v-col>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="cancel-button px-3" text @click="dialog = false">
                {{ $t('cancel') }}
              </v-btn>
              <v-btn class="confirm-button px-5" text @click="dialog = false">
                {{ $t('done') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDialog" max-width="500px" persistent>
          <v-card>
            <v-card-title class="headline primary white--text">{{ $t('confirmation') }}</v-card-title>
            <v-card-text class="v-card__text mt-4">{{ $t('send_notification_confirm', [recipientCount]) }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="cancel-button px-5" text @click="confirmDialog = false">
                {{ $t('cancel') }}
              </v-btn>
              <v-btn class="confirm-button px-5" text :loading="inuse" @click="confirmSend">
                {{ $t('send_notification') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
            v-model="notificationResultsDialog"
            max-width="800px"
            persistent
        >
          <v-card>
            <v-card-title class="dialog-title">
              <span class="headline">{{ $t('notification_results')}}</span>
            </v-card-title>
            <v-divider v-if="notificationResults && notificationResults.length>1"></v-divider>
            <!--  eslint-disable-next-line -->
            <v-list-item v-for="(item, i) in notificationResults" :key="i">
              <v-list-item-content class="px-2">
                <div v-if="item.result"> {{ $t('notification_succcessfull', [item.firstname, item.lastname, item.email]) }}</div>
                <div v-else> {{ $t('notification_unsuccessfull', [item.firstname, item.lastname, item.email]) }}</div>
              </v-list-item-content>

            </v-list-item>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" dark @click="closeNotificationResultsDialog"
              >{{ $t('acknowledged')}}</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </v-layout>
</template>

<style scoped>
</style>
<style>
.emoji-textarea {
  position: relative;
}
.emoji-textarea .emoji-trigger {
  position: absolute;
  right: 8px;
  bottom: 30px;
  cursor: pointer;
  z-index: 1;
}
.emoji-textarea textarea {
  box-sizing: border-box;
  padding-right: 24px;
}
.emoji-picker {
  max-width: 264px;
  display: flex;
  flex-wrap: wrap;
}
.emoji-item {
  font-size: 20px;
  line-height: 1.6;
  padding: 2px 5px;
  cursor: pointer;
  user-select: none;
}
.emoji-item:hover {
  background: rgba(0, 0, 0, 0.06);
  border-radius: 4px;
}
</style>
